export const ENTITY_TYPES = [
  { slug: "fattoria-didattica", name: "Fattoria didattica" },
  { slug: "city-farm", name: "City farm" },
  { slug: "realta-educativa", name: "Realtà educativa in natura" },
  { slug: "scuola-aperto", name: "Scuola all'aperto" },
  { slug: "azienda-agricola", name: "Azienda agricola" },
  { slug: "cooperativa-sociale", name: "Cooperativa sociale" },
  { slug: "altro", name: "Altro" },
];

export const ENTITY_LABELS = Object.fromEntries(
  ENTITY_TYPES.map((e) => [e.slug, e.name])
);

/**
 * Returns human-readable label for a company entity type,
 * with the custom label used when type === "altro".
 */
export function entityTypeLabel(company) {
  if (!company?.entity_type) return "";
  if (company.entity_type === "altro") {
    return (company.entity_type_custom || "").trim() || "Altro";
  }
  return ENTITY_LABELS[company.entity_type] || "";
}
